import axios from 'axios';
import { Notification } from 'element-ui';

// 创建axios实例
const service = axios.create({
    timeout: 100000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        if(response.data.errcode === -1){
            // Notification({
            //     title: '提示',
            //     message: response.data.errmsg,
            //     type: 'error',
            //     duration: 4 * 1000
            // });
            return response.data
        } else {
            return response.data
        }
    },
    error => {
        // Notification({
        //     title: '提示',
        //     message: '系统繁忙',
        //     type: 'warning',
        //     duration: 1 * 1000
        // });
        return Promise.reject(error)
    }
)

export default service
